module.exports = __webpack_public_path__ + "img/logoloading.b30e5dd9.gif";